import { render, staticRenderFns } from "./InventoryReservationView.vue?vue&type=template&id=32cff568"
import script from "./InventoryReservationView.vue?vue&type=script&lang=js"
export * from "./InventoryReservationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports